export const Api_Url = "https://dev-api.queenwars.io"